import { useState } from 'react';
import { Box, FormControlLabel, InputBase, makeStyles, Checkbox } from '@material-ui/core';
import Dialog from '../../../../components/Dialog';

const useStyles = makeStyles(() => ({
  title: {
    fontFamily: 'NotoSans-Medium',
    fontSize: '0.875rem',
    color: '#7d86a9',
  },
  star: {
    color: '#ff0000',
  },
  input: {
    width: '100%',
    height: '3.5rem',
    padding: '1.25rem',
    border: 'solid 1px #e4e7eb',
    borderRadius: '10px',
    fontFamily: 'NotoSans-Medium',
    fontSize: '1rem',
    color: '#2e4469',
  },
  content: {
    fontFamily: 'NotoSans-Medium',
    fontSize: '1rem',
    color: '#2e4469',
  },
  checkBox: {
    '& .MuiCheckbox-root': {
      color: '#c0c6cb',
    },
    '& .MuiTypography-root': {
      fontFamily: 'NotoSans-Medium',
      fontSize: '1rem',
      fontWeight: '500',
      color: '#2e4469',
    },
    '& .Mui-checked': {
      color: '#28d2ab',
    },
  },
}));

const EditRemark = ({ data, handleClose, handleConfirm }) => {
  const classes = useStyles();
  const [form, setForm] = useState(data);

  const handleChange = (e, type) => {
    if (type === 'remark') {
      setForm({ ...form, remark: e.target.value });
    } else {
      setForm({ ...form, status: e.target.checked });
    }
  };

  return (
    <Dialog
      open={true}
      title={form?.remarkId ? 'Edit Remarks' : 'Add Remarks'}
      cancel="Cancel"
      confirm="Confirm"
      cancelStyle={{ border: 'unset' }}
      handleCancel={handleClose}
      handleClose={handleClose}
      handleConfirm={() => handleConfirm(form)}
      disabled={!form?.remark}
    >
      <Box display="flex" flexDirection="column" gridGap="1.25rem">
        <Box display="flex" flexDirection="column" gridGap="0.75rem">
          <div className={classes.title}>Remarks name</div>
          <InputBase className={classes.input} value={form.remark} onChange={(e) => handleChange(e, 'remark')} />
        </Box>
        <FormControlLabel
          control={<Checkbox />}
          label="ACTIVE"
          checked={form.status}
          onChange={(e) => handleChange(e, 'status')}
          className={classes.checkBox}
        />
      </Box>
    </Dialog>
  );
};

export default EditRemark;
